<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';

const props = defineProps({
  imovel: { type: Object, required: true },
  businessContext: { type: String, default: 'rental' },
});

const isPartnerProperty = computed(() =>
  Boolean(props.imovel?.additional_attributes?.rede_partner)
);
const partnerName = computed(
  () =>
    props.imovel?.additional_attributes?.rede_partner_name ||
    'imobiliária parceira'
);
const visitOwnership = computed(
  () =>
    props.imovel?.additional_attributes?.rede_visit_ownership ||
    partnerName.value
);
const partnerTitle = computed(() => `Imóvel de ${partnerName.value}`);
const visitOwnershipLabel = computed(
  () => `Visita administrada por ${visitOwnership.value}.`
);
const contractAdmin = computed(() =>
  props.businessContext === 'rental'
    ? 'Contrato administrado pela Imudei.'
    : null
);
</script>

<template>
  <div
    v-show="isPartnerProperty"
    class="rounded-lais border border-amber-200 bg-amber-50 px-4 py-3 text-[12px] leading-5 text-amber-900"
  >
    <p class="font-semibold uppercase tracking-wide text-[11px]">
      {{ partnerTitle }}
    </p>
    <p>{{ visitOwnershipLabel }}</p>
    <p v-if="contractAdmin" class="mt-1">{{ contractAdmin }}</p>
  </div>
</template>
